import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Col, Container, Row, Spinner, Table } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import { apiCall } from "../services/AxiosService";
import Loader, { LoaderType } from "../component/common-component/Loader";
import Nodata from "../component/common-component/Nodata";
import { GetSubscriberByPrimaryKey } from "../services/ReduxTookit/Slice/SubscribersRedux";
import { useDispatch, useSelector } from "react-redux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import profilepic from "../assets/images/My_machine.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import deleteAction from "../assets/images/deleteaction.svg";
import buymoremachine from "../assets/images/buymoremachine.svg";
import wallet from "../assets/images/wallet.svg";
import Creaditcard from "../assets/images/Creaditcard.svg";
import { useNavigate } from "react-router-dom";
import { CartGetList } from "../services/ReduxTookit/Slice/CartRedux";
import moment from "moment";
import DeleteModal from "./DeleteModal";
import SubscriberTermsAndCondition from "./SubscriberTermsAndCondition";
import { OrderSave } from "../services/ReduxTookit/Slice/OrderRedux";
import { InvoiceSave } from "../services/ReduxTookit/Slice/InvoiceRedux";
import { commonservices } from "../services/CommonServices";
import DatePicker from "react-datepicker";

const AddToCartModal = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [DeletePayload, setDeletePayload] = useState("");
  const [TandCShow, setTandCShow] = useState(false);
  const [TandCLoader, setTandCLoader] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const CartList = useSelector(
    (state) => state?.cartredux?.CartGetListData?.data?.data?.data
  );

  const GetCartDetails = () => {
    dispatch(CartGetList({}));
  };

  const saveOrder = async () => {
    setTandCLoader(true);
    dispatch(OrderSave()).then((res) => {
      if (res?.payload?.isValidate) {
        let body = {
          orderid: res?.payload?.data?.data?.orderid
            ? parseInt(res?.payload?.data?.data?.orderid)
            : 0,
          usermopid: 0,
          ispaymentcomplete: true,
          mop_term: "abc",
          paymentnote: "abc",
          caseid: 0,
        };
        dispatch(InvoiceSave(body))
          .then((invoiceRes) => {
            if (invoiceRes?.payload?.isValidate) {
              navigate("/marketplace");
              dispatch(CartGetList({}));
              setTandCShow(false);
              if (props?.onHide) {
                props?.onHide();
              }
              if (props?.handlePlaceOrder) {
                props?.handlePlaceOrder();
              }
            } else {
            }
          })
          .finally(() => {
            setTandCLoader(false);
          });
      } else {
        setTandCLoader(false);
      }
    });
  };

  useEffect(() => {
    GetCartDetails();
  }, []);
  return (
    <div>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        className="addto-card-model"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add to Cart
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="p-0">
            <div className="full-height-table w-100 bcmtop-main-wrapper">
              <Row className="mb-2">
                <Col xl={8} className="p-0 cart-left-box">
                  <div className="main-page-content">
                    <div className="table-wrapper-main">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th className="width200">Machine Name</th>
                            <th className="width150">Developer Name</th>
                            <th className="width125">Innovation</th>
                            <th className="text-end width100">Price</th>
                            <th className="text-end sticky-actions">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {CartList ? (
                              CartList?.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td className="theme-color-text fw600">
                                      <img
                                        className="small-profile-pic with-ring"
                                        src={
                                          item?.machinelogo
                                            ? item?.machinelogo
                                            : DemoLogo
                                        }
                                        alt="profilepic"
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null;
                                          currentTarget.src = DemoLogo;
                                        }}
                                      />
                                      <span
                                        className="ms-2"
                                        title={item?.machinename}
                                      >
                                        {commonservices.truncateText(
                                          item?.machinename,
                                          12
                                        )}
                                      </span>
                                    </td>
                                    <td title={item?.displayname}>
                                      {commonservices.truncateText(
                                        item?.displayname,
                                        12
                                      )}
                                    </td>
                                    <td>
                                      Since{" "}
                                      {moment(item?.lastupdatedon).format(
                                        "YYYY"
                                      )}
                                    </td>
                                    <td className="text-end">$ {item?.amount}</td>
                                    <td className="sticky-actions">
                                      <div className="all-actions">
                                        <img
                                          src={deleteAction}
                                          alt="deleteAction"
                                          title="Delete"
                                          onClick={() => {
                                            setDeletePayload(
                                              item?.cartdetailid
                                            );
                                            setModalShow(true);
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr className="text-center">
                                <td colSpan={5}>
                                  <Nodata />
                                </td>
                              </tr>
                            )}
                          </>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="d-flex me-3 cart-quantity-amount">
                    <div className="workflow-notdata">
                      <div className="more-machine-main d-flex">
                        <div className="more-machine-icon mr-2">
                          <img src={buymoremachine} alt="buymoremachine" />
                        </div>
                        <div className="more-machine-detail">
                          <h3>Buy More Machines</h3>
                          <p>
                            Boost your data processing power adding more
                            machines for faster & scalable insights.
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          navigate("/marketplace");
                          props?.onHide();
                        }}
                        className="blue-btn  mt-3"
                      >
                        Explore Marketplace
                      </button>
                    </div>
                    <div className="addtocart-totalamount">
                      <div className="totalamount-detail totalamoun-bottom">
                        <h4>Quantity</h4>
                        <span>
                          {CartList ? CartList[0]?.totalordereditems : 0}
                        </span>
                      </div>
                      <div className="totalamount-detail">
                        <h4>Total Amount</h4>
                        <span>${CartList ? CartList[0]?.totalordered : 0}</span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={4} className="pe-0">
                  <div className="checkout-addtocart">
                    <div className="checkout-add-header">
                      <h4>Payment Info</h4>
                    </div>
                    <div className="checkout-add-body">
                      <div className="checkout-common">
                        <h5>Payment Method</h5>
                        <div className="paymeantinfo">
                          <div className="Creaditcard d-flex gap-2 align-item-center">
                            <input
                              style={{ accentcolor: "#2490D2" }}
                              type="radio"
                              id="auth-app2"
                              name="seversity"
                              // checked={
                              //   supportInput .seversity === itm?.term
                              //     ? true
                              //     : false
                              // }
                            />
                            <label htmlFor="auth-app2">
                              <div className=" d-flex gap-2 align-item-center paymentaddtocard">
                                <img src={Creaditcard} alt="Creaditcard" />
                                <p>Credit/Debit Card</p>
                              </div>
                            </label>
                          </div>
                          <div className="wallet d-flex gap-2 align-item-center">
                            <input
                              style={{ accentcolor: "#2490D2" }}
                              type="radio"
                              id="auth-app3"
                              name="seversity"
                              // checked={
                              //   supportInput .seversity === itm?.term
                              //     ? true
                              //     : false
                              // }
                            />
                            <label htmlFor="auth-app3">
                              <div className=" d-flex gap-2 align-item-center paymentaddtocard">
                                <img src={wallet} alt="wallet" />
                                <p>wallet</p>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="checkout-common">
                        <h5>Card Number</h5>
                        <div className="paymeantinfo">
                          <Form.Control
                            // style={{
                            //   border:
                            //     inputAuth?.length === 6
                            //       ? ""
                            //       : AuthOTP
                            //       ? "1px solid red"
                            //       : "1px solid var(--blue2b)",
                            // }}
                            placeholder="****  ****  ****  ****"
                            className="login-input"
                            maxLength={16}
                            // value={inputAuth}
                            // onChange={(e) => {
                            //   setInputAuth(e.target.value);
                            // }}
                            // onKeyUp={(e) => {
                            //   if (inputAuth?.length === 6 && e.key === "Enter") {
                            //     Call2FAVerifyFunction();
                            //   }
                            // }}
                          />
                        </div>
                      </div>
                      <div className="checkout-common">
                        <h5>name on Card</h5>
                        <div className="paymeantinfo">
                          <Form.Control
                            // style={{
                            //   border:
                            //     inputAuth?.length === 6
                            //       ? ""
                            //       : AuthOTP
                            //       ? "1px solid red"
                            //       : "1px solid var(--blue2b)",
                            // }}
                            placeholder="name"
                            className="login-input"
                            // maxLength={16}
                          />
                        </div>
                      </div>
                      <Row>
                        <Col md={8}>
                          <div className="checkout-common">
                            <h5>Expiry Date</h5>
                            <div className="paymeantinfo">
                              {/* <Form.Select aria-label="Default select example">
                                <option></option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                              </Form.Select> */}
                              <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                dateFormat="MM/yy"
                                showMonthYearPicker
                                showYearDropdown={false}
                                placeholderText="Select Date"
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="checkout-common">
                            <h5>CVV</h5>
                            <div className="paymeantinfo">
                              <Form.Control
                                placeholder="***"
                                className="login-input"
                                maxLength={3}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <div>
                        <button
                          disabled={!CartList}
                          className={
                            CartList ? "blue-btn mt-3" : "disable-blue-btn mt-3"
                          }
                          onClick={() => {
                            if (CartList) {
                              setTandCShow(true);
                            }
                          }}
                        >
                          Checkout
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Modal.Body>
      </Modal>
      {modalShow && (
        <DeleteModal
          payload={{ id: DeletePayload }}
          url={API_URL.CART.DELETE_CART_DETAIL}
          show={modalShow}
          bindlist={GetCartDetails}
          onHide={(e) => setModalShow(false)}
        />
      )}
      {TandCShow && (
        <SubscriberTermsAndCondition
          show={TandCShow}
          onsubmit={saveOrder}
          loader={TandCLoader}
          subscriberId={props?.subscriberId}
          // verifytext={setVerifymailText}
          onHide={() => setTandCShow(false)}
        />
      )}
    </div>
  );
};

export default AddToCartModal;
